/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_Style_DescriptionInputs */

const en_caption_style_description = /** @type {(inputs: Caption_Style_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a caption style and apply it to selected events`)
};

const fr_caption_style_description = /** @type {(inputs: Caption_Style_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez un style de sous-titrage et appliquez-le aux événements sélectionnés`)
};

const de_caption_style_description = /** @type {(inputs: Caption_Style_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie einen Bildunterschriftenstil und wenden Sie ihn auf ausgewählte Ereignisse an.`)
};

const it_caption_style_description = /** @type {(inputs: Caption_Style_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli uno stile di didascalia e applicalo agli eventi selezionati`)
};

const ru_caption_style_description = /** @type {(inputs: Caption_Style_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите стиль подписи и примените его к выбранным событиям.`)
};

const es_caption_style_description = /** @type {(inputs: Caption_Style_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elija un estilo de subtítulo y aplíquelo a los eventos seleccionados`)
};

const zh_cn2_caption_style_description = /** @type {(inputs: Caption_Style_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一种标题样式并将其应用于选定的活动`)
};

const ja_caption_style_description = /** @type {(inputs: Caption_Style_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションのスタイルを選択し、選択したイベントに適用します`)
};

const hi_caption_style_description = /** @type {(inputs: Caption_Style_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन शैली चुनें और उसे चयनित इवेंट्स पर लागू करें।`)
};

const pt_pt2_caption_style_description = /** @type {(inputs: Caption_Style_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha um estilo de legenda e aplique-o aos eventos selecionados.`)
};

/**
* | output |
* | --- |
* | "Choose a caption style and apply it to selected events" |
*
* @param {Caption_Style_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_style_description = /** @type {((inputs?: Caption_Style_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Style_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_caption_style_description(inputs)
	if (locale === "de") return de_caption_style_description(inputs)
	if (locale === "it") return it_caption_style_description(inputs)
	if (locale === "ru") return ru_caption_style_description(inputs)
	if (locale === "es") return es_caption_style_description(inputs)
	if (locale === "zh-CN") return zh_cn2_caption_style_description(inputs)
	if (locale === "ja") return ja_caption_style_description(inputs)
	if (locale === "hi") return hi_caption_style_description(inputs)
	if (locale === "pt-PT") return pt_pt2_caption_style_description(inputs)
	return en_caption_style_description(inputs)
});